import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["orientation", "opts", "setApi", "plugins", "className", "children"],
      _excluded2 = ["className"],
      _excluded3 = ["className"],
      _excluded4 = ["className", "variant", "size"],
      _excluded5 = ["className", "variant", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { cn } from '@/shadcn/lib/utils';
import { Button } from '@/shadcn/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CarouselContext = /*#__PURE__*/React.createContext(null);

function useCarousel() {
  const context = React.useContext(CarouselContext);

  if (!context) {
    throw new Error('useCarousel must be used within a <Carousel />');
  }

  return context;
}

const Carousel = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    orientation = 'horizontal',
    opts,
    setApi,
    plugins,
    className = '',
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const [carouselRef, api] = useEmblaCarousel(_objectSpread(_objectSpread({}, opts), {}, {
    axis: orientation === 'horizontal' ? 'x' : 'y'
  }), plugins);
  const [canScrollPrev, setCanScrollPrev] = React.useState(false);
  const [canScrollNext, setCanScrollNext] = React.useState(false);
  const onSelect = React.useCallback(api => {
    if (!api) {
      return;
    }

    setCanScrollPrev(api.canScrollPrev());
    setCanScrollNext(api.canScrollNext());
  }, []);
  const scrollPrev = React.useCallback(() => {
    api === null || api === void 0 ? void 0 : api.scrollPrev();
  }, [api]);
  const scrollNext = React.useCallback(() => {
    api === null || api === void 0 ? void 0 : api.scrollNext();
  }, [api]);
  const handleKeyDown = React.useCallback(event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      scrollPrev();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      scrollNext();
    }
  }, [scrollPrev, scrollNext]);
  React.useEffect(() => {
    if (!api || !setApi) {
      return;
    }

    setApi(api);
  }, [api, setApi]);
  React.useEffect(() => {
    if (!api) {
      return;
    }

    onSelect(api);
    api.on('reInit', onSelect);
    api.on('select', onSelect);
    return () => {
      api === null || api === void 0 ? void 0 : api.off('select', onSelect);
    };
  }, [api, onSelect]);
  return /*#__PURE__*/_jsx(CarouselContext.Provider, {
    value: {
      carouselRef,
      api: api,
      opts,
      orientation: orientation || ((opts === null || opts === void 0 ? void 0 : opts.axis) === 'y' ? 'vertical' : 'horizontal'),
      scrollPrev,
      scrollNext,
      canScrollPrev,
      canScrollNext
    },
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      ref: ref,
      onKeyDownCapture: handleKeyDown,
      className: cn('relative', className),
      role: "region",
      "aria-roledescription": "carousel"
    }, props), {}, {
      children: children
    }))
  });
});
Carousel.displayName = 'Carousel';
const CarouselContent = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className = ''
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  const {
    carouselRef,
    orientation
  } = useCarousel();
  return /*#__PURE__*/_jsx("div", {
    ref: carouselRef,
    className: "overflow-hidden",
    children: /*#__PURE__*/_jsx("div", _objectSpread({
      ref: ref,
      className: cn('flex', orientation === 'horizontal' ? '-ml-4' : '-mt-4 flex-col', className)
    }, props))
  });
});
CarouselContent.displayName = 'CarouselContent';
const CarouselItem = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className = ''
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  const {
    orientation
  } = useCarousel();
  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref,
    role: "group",
    "aria-roledescription": "slide",
    className: cn('min-w-0 shrink-0 grow-0 basis-full', orientation === 'horizontal' ? 'pl-4' : 'pt-4', className)
  }, props));
});
CarouselItem.displayName = 'CarouselItem';
const CarouselPrevious = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    className = '',
    variant = 'outline',
    size = 'icon'
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  const {
    orientation,
    scrollPrev,
    canScrollPrev
  } = useCarousel();
  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
    ref: ref,
    variant: variant,
    size: size,
    className: cn('absolute  h-8 w-8 rounded-full', orientation === 'horizontal' ? '-left-12 top-1/2 -translate-y-1/2' : '-top-12 left-1/2 -translate-x-1/2 rotate-90', className),
    disabled: !canScrollPrev,
    onClick: scrollPrev
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(ArrowLeft, {
      className: "h-4 w-4"
    }), /*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: "Previous slide"
    })]
  }));
});
CarouselPrevious.displayName = 'CarouselPrevious';
const CarouselNext = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    className = '',
    variant = 'outline',
    size = 'icon'
  } = _ref5,
      props = _objectWithoutProperties(_ref5, _excluded5);

  const {
    orientation,
    scrollNext,
    canScrollNext
  } = useCarousel();
  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
    ref: ref,
    variant: variant,
    size: size,
    className: cn('absolute h-8 w-8 rounded-full', orientation === 'horizontal' ? '-right-12 top-1/2 -translate-y-1/2' : '-bottom-12 left-1/2 -translate-x-1/2 rotate-90', className),
    disabled: !canScrollNext,
    onClick: scrollNext
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(ArrowRight, {
      className: "h-4 w-4"
    }), /*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: "Next slide"
    })]
  }));
});
CarouselNext.displayName = 'CarouselNext';
export { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext };